import { z } from 'zod';
export const AiFeatureFlagsSchema = z.object({
  ai_error_explanation_enabled: z.boolean().transform(val => val),
  ai_explain_solution_enabled: z.boolean().transform(val => val),
  ai_hints_or_incorrect_submition_enabled: z.boolean().transform(val => val)
}).transform(data => ({
  aiErrorExplanationEnabled: data.ai_error_explanation_enabled,
  aiExplainSolutionEnabled: data.ai_explain_solution_enabled,
  aiHintsOrIncorrectSubmitionEnabled: data.ai_hints_or_incorrect_submition_enabled
}));